// Full-color wordmarks with transparent backgrounds
const LOGO_IVORY_URL = "https://customer-assets.emergentagent.com/job_client-desk-6/artifacts/srikvmmy_indie-law-fullcolor-ivory.png";
const LOGO_NAVY_URL = "https://customer-assets.emergentagent.com/job_client-desk-6/artifacts/mm07ldnr_indie-law-fullcolor-navy.png";

/**
 * IndieLawLogo
 * - variant="light" → ivory wordmark (use on dark / navy backgrounds)
 * - variant="dark"  → navy wordmark  (use on light / warm-white backgrounds)
 *
 * Pass a custom `className` (e.g. "h-16") to override the default size.
 */
export default function IndieLawLogo({ variant = 'dark', className = '' }) {
  const src = variant === 'light' ? LOGO_IVORY_URL : LOGO_NAVY_URL;
  // Default size bumped for readability. Callers can override via className.
  const sizeClass = className || 'h-12 w-auto';

  return (
    <div className="flex items-center" data-testid="indie-law-logo">
      <img
        src={src}
        alt="Indie Law"
        className={sizeClass}
        style={{ objectFit: 'contain' }}
      />
    </div>
  );
}
